import { render, staticRenderFns } from "./TasksSettingsCategoriesList.vue?vue&type=template&id=630f575a&scoped=true&"
import script from "./TasksSettingsCategoriesList.vue?vue&type=script&lang=js&"
export * from "./TasksSettingsCategoriesList.vue?vue&type=script&lang=js&"
import style0 from "./TasksSettingsCategoriesList.vue?vue&type=style&index=0&id=630f575a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630f575a",
  null
  
)

export default component.exports